document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector('x-header[data-section-id]');
  if (!header) return;

  const menuLabel = header.querySelector(".menu-label");
  const hamburgerBtn = header.querySelector('button[aria-controls="sidebar-menu"]');
  if (!menuLabel || !hamburgerBtn) return;

  menuLabel.style.cursor = "pointer";

  // Remove previous listeners
  const newLabel = menuLabel.cloneNode(true);
  menuLabel.replaceWith(newLabel);

  newLabel.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    hamburgerBtn.click();
  });
});
